// src/components/icons/IconLogo.js
import React from 'react';
import PropTypes from 'prop-types';

/**
 * Word‑mark:  αlans
 *
 * `scale` enlarges both glyph and text without
 *
 */
const IconLogo = ({ scale = 6, ...svg }) => {
  // derived geometry
  const vBoxW = 90 * scale;
  const vBoxH = 30 * scale;
  const alphaScale = scale * 1.035;
  const stroke   = 0.45 * scale;
  const fontSize = 21  * scale;
  const textX    = 23.375  * scale;
  const textY    = 23  * scale;
  const letterSp =  1.43  * scale;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${vBoxW} ${vBoxH}`}
      {...svg}                 /* width / height via CSS or props */
    >
      {/* α glyph */}
      <g
        transform={`translate(0 ${3 * scale}) scale(${alphaScale})`}
        fill="none"
        stroke="currentColor"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M18.1 6c-1.1 2.913-1.9 4.913-2.4 6c-1.879 4.088-3.713 6-6 6c-2.4 0-4.8-2.4-4.8-6s2.4-6 4.8-6c2.267 0 4.135 1.986 6 6c.512 1.102 1.312 3.102 2.4 6" />
      </g>

      {/* “lans” */}
      <text
        x={textX}
        y={textY}
        fill="currentColor"
        fontSize={fontSize}
        fontFamily="sans-serif"
        letterSpacing={letterSp}
      >
        lans
      </text>
    </svg>
  );
};

IconLogo.propTypes = {
  scale: PropTypes.number,
};

export default IconLogo;
